import { useLang } from "./LangContext";
import { Soon } from "./Reveal";

export const HourlyPrice = ({ value, testid }) => {
  const { lang, t } = useLang();
  if (value == null) return <Soon text={t.pricing.soon} testid={testid} />;

  const amount = new Intl.NumberFormat(lang === "tr" ? "tr-TR" : "en-GB", {
    maximumFractionDigits: 2,
  }).format(value);

  return (
    <p className="hourly-price" data-testid={testid}>
      <span className="price-amount font-display">{amount} TL</span>
      <span className="price-unit">{" / "}{t.pricing.hour}</span>
    </p>
  );
};
